// Maybe add styled components?

import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { useStaticQuery, graphql } from "gatsby";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";
import logo from "../images/mev-icon.png";

const CornerPageTop = ({ links, post }) => {
  const { comp } = useStaticQuery(
    graphql`
      query {
        comp: allWpEmployee {
          edges {
            node {
              title
              featuredImage {
                node {
                  altText
                  sourceUrl
                }
              }
            }
          }
        }
      }
    `
  );

  const authorImg =
    post?.author?.node?.name &&
    comp?.edges
      ?.filter(({ node }) => post?.author?.node.name === node.title)
      .map((ansatt) => ansatt.node.featuredImage?.node?.sourceUrl)?.[0];

  const months = [
    _("Januar"),
    _("Februar"),
    _("Mars"),
    _("April"),
    _("Mai"),
    _("Juni"),
    _("Juli"),
    _("August"),
    _("September"),
    _("Oktober"),
    _("November"),
    _("Desember"),
  ];

  return post ? (
    <div className="hero-blogpost">
      <div className="blogpost-textbox">
        <div className="hide-mobile">
          <Link
            to={post.categories?.nodes?.[0]?.uri?.replace("/category", "")}
            className="blogpost-textbox-category"
          >
            {post.categories?.nodes?.[0]?.name?.replace("&amp;", "&")}
          </Link>
        </div>
        <h1 className="blogpost-textbox-title">
          {post.title?.replace("&#8211;", "-")}
        </h1>
        <div className="blogpost-textbox-data-desktop">
          <div className="textbox-authorbox">
            <ImageLibpixel
              src={authorImg !== undefined ? authorImg : logo}
              alt={_("forfatter")}
              className="authorbox-img"
            />
            <p className="authorbox-name">{post.author?.node?.name}</p>
          </div>
          <p className="blogpost-textbox-category-label">
            {_("Kategori")}:{" "}
            <Link
              to={post.categories?.nodes?.[0]?.uri?.replace("/category", "")}
              className="blogpost-textbox-category"
            >
              {post.categories?.nodes?.[0]?.name?.replace("&amp;", "&")}
            </Link>
          </p>
          <p className="datebox-changed">
            {post.modified !== post.date
              ? _("Sist endret") +
                ": " +
                new Date(post.modified).getDate() +
                ". " +
                months[new Date(post.modified).getMonth()].toLowerCase() +
                " " +
                new Date(post.modified).getFullYear()
              : _("Publisert") +
                ": " +
                new Date(post.date).getDate() +
                ". " +
                months[new Date(post.date).getMonth()].toLowerCase() +
                " " +
                new Date(post.date).getFullYear()}
          </p>
        </div>
      </div>
      <ImageLibpixel
        src={post.featuredImage?.node?.sourceUrl}
        alt={post.featuredImage?.node?.altText}
        className="blogpost-img"
      />
      <div className="blogpost-textbox-data-mobile">
        <div className="textbox-authorbox">
          <ImageLibpixel
            src={authorImg !== undefined ? authorImg : logo}
            alt={_("forfatter")}
            className="authorbox-img"
          />
          <span>
            <p className="authorbox-name">{post.author?.name}</p>
            <p className="datebox-changed">
              {post.modified !== post.date
                ? _("Sist endret") +
                  ": " +
                  new Date(post.modified).getDate() +
                  ". " +
                  months[new Date(post.modified).getMonth()].toLowerCase() +
                  " " +
                  new Date(post.modified).getFullYear()
                : _("Publisert") +
                  ": " +
                  new Date(post.date).getDate() +
                  ". " +
                  months[new Date(post.date).getMonth()].toLowerCase() +
                  " " +
                  new Date(post.date).getFullYear()}
            </p>
          </span>
        </div>
      </div>
    </div>
  ) : (
    <div>
      <h1 className="cornerpage-title">{post.title}</h1>
      <div className="cornerpage-top-container-alt">
        {links?.map((link, i) => (
          <div key={i} className="hidden-container">
            {link.title && (
              <div className={`box-alt bg-${i > 0 ? "red" : "blue"}`}>
                <Link to={link.url} className="box-title-alt">
                  {link.title}
                </Link>
              </div>
            )}
            <div className="box-img-container-alt">
              <div className="box-shadow-alt" />
              <ImageLibpixel
                src={link.img?.sourceUrl}
                alt={_("artikkler")}
                className="box-img-alt"
              />
            </div>
          </div>
        ))}

        <ImageLibpixel
          src={post.featuredImage?.node?.sourceUrl}
          alt={post.featuredImage?.node?.altText}
          className="cornerpage-top-img"
        />
      </div>
    </div>
  );
};

CornerPageTop.propTypes = {
  links: PropTypes.array,
  post: PropTypes.object,
};

CornerPageTop.defaultProps = {
  links: undefined,
  post: undefined,
};

export default CornerPageTop;
